module.exports = __webpack_public_path__ + "img/empty.a6b7ec68.svg";